export const GTM_EVENTS = {
  LOGIN_SUCCESS: 'login_success',
  REGISTER_SUCCESS: 'register_success',
  LOGOUT: 'logout',
  COURSE_VIEWED: 'course_viewed',
  COURSE_ENROLLMENT_STARTED: 'course_enrollment_started',
  COURSE_ENROLLMENT_COMPLETED: 'course_enrollment_completed',
  COURSE_LESSON_STARTED: 'course_lesson_started',
  COURSE_LESSON_COMPLETED: 'course_lesson_completed',
  COURSE_CERTIFICATE_VIEWED: 'course_certificate_viewed',
  LIVE_VIEWED: 'live_viewed',
  LIVE_PARTICIPATION_SUBMITTED: 'live_participation_submitted',
  LIVE_ASSESSMENT_STARTED: 'live_assessment_started',
  LIVE_ASSESSMENT_SUBMITTED: 'live_assessment_submitted',
  LIVE_CERTIFICATE_VIEWED: 'live_certificate_viewed',
  PROFILE_UPDATED: 'profile_updated',
  PASSWORD_CHANGED: 'password_changed',
} as const;

export type GtmEventName = (typeof GTM_EVENTS)[keyof typeof GTM_EVENTS];
